import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/blogs.css'; 

const blogsData = [
  {
    id: 1,
    title: 'How to Register and Verify Your Account on the Reddyanna App',
    date: '2024-09-29',
    author: 'Vikash Roy',
    views: 5731,
    likes: 623,
    comments: 0,
    excerpt: 'Learn how to easily register and verify your account on the Reddyanna app. Follow...',
    imageUrl: '/blog1.webp',
    slug: 'how-to-register-and-verify-your-account-on-the-reddyanna-app',
  },
  {
    id: 2,
    title: 'Reddy Anna App: Features, Benefits, and Installation Guide',
    date: '2024-09-25',
    author: 'Vikash Roy',
    views: 5391,
    likes: 593,
    comments: 0,
    excerpt: 'Explore the features, benefits, and a complete installation guide for the Reddy...',
    imageUrl: '/blog2.webp', 
    slug: 'reddy-anna-app-features-benefits-and-installation-guide',
  },
  {
    id:3,
      title: "Online Cricket Betting: From How to Place Bet to Successful Tips",
      date: "2025-04-25",
      author: "Vikash Roy",
      views: 6078,
      likes: 493,
    comments: 0,
    excerpt: "Learn how to place a bet, how to win, and how to make money with online cricket betting. Follow...",
      imageUrl: "/blog3.webp",
      slug: "online-cricket-betting-from-how-to-place-bet-to-successful-tips",
  },
  {
    id:4,
      title: "Cricket Betting Tips 2025: Expert Guide for Beginners to Win Big",
      date: "2025-04-30",
      author: "Vikash Roy",
      views: 5869,
      likes: 440,
    comments: 0,
    excerpt: "Cricket is so much more than just a game, it's a worldwide phenomenon that brings countries...",
      imageUrl: "/blog4.webp",
      slug: "cricket-betting-tips-2025-expert-guide-for-beginners-to-win-big",
  },
  {
  id: 5,
  title: "Exploring the Exciting World of Cricket Betting Exchanges",
  date: "2025-05-14",
  author: "Vikash Roy",
  views: 6721,
  likes: 515,
  comments: 0,
  excerpt: "For many cricket fans, watching a match is more than just a game — it's a passion. The sound of the ...",
  imageUrl: "/blog5.webp",
  slug: "exploring-the-exciting-world-of-cricket-betting-exchanges",
},
// {
//   id: 6,
//   title: "Decoding the Matrix: A Guide into Cricket Betting Odds",
//   date: "2025-05-20",
//   author: "Vikash Roy",
//   views: 6081,
//   likes: 398,
//   comments: 0,
//   excerpt: "Understand how cricket betting odds work, how to read them, and how live odds can guide smarter bets...",
//   imageUrl: "/blog6.webp",
//   slug: "decoding-the-matrix-a-guide-into-cricket-betting-odds",
// }
{
  id: 7,
  slug: "the-art-and-science-of-cricket-betting-prediction",
  title: "The Art and Science of Cricket Betting Prediction",
  date: "2025-05-22",
  author: "Vikash Roy",
  views: 6121,
  likes: 306,
  comments: 0,
  excerpt: "Cricket is a game of glorious uncertainties, which is precisely why it's so captivating. But...",
  imageUrl: "/blog7.webp",
},
{
  id: 8,
  slug: "mastering-the-art-how-to-bet-in-cricket-online",
  title: "Mastering the Art: How to Bet in Cricket Online",
  date: "2025-05-24",
  author: "Vikash Roy",
  views: 5771,
  likes: 306,
  comments: 0,
  excerpt: "Cricket has always been a game of glorious uncertainties. That same unpredictability fuels...",
  imageUrl: "/blog8.webp",
},
{
  id: 9,
  slug: "tennis-the-ultimate-betting-playbook",
  title: "Tennis: The Ultimate Betting Playbook",
  date: "2025-05-30",
  author: "Vikash Roy",
  views: 8881,
  likes: 201,
  comments: 0,
  excerpt: "Tennis is one of the most entertaining sports to bet on due to its unpredictabilit...",
  imageUrl: "/blog9.webp",
},
{
  id: 10,
  slug: "the-ultimate-playbook-how-to-bet-on-football-games",
  title: "The Ultimate Playbook: How to Bet on Football Games",
  date: "2025-06-02",
  author: "Vikash Roy",
  views: 7781,
  likes: 341,
  comments: 0,
  excerpt: " Football, which is known as football in many parts of the world, is not just the globe's...",
  imageUrl: '/blog10.webp',
},
{
  id: 11,
  slug: "tennis-betting-odds-everything-you-need-to-know",
  title: "Tennis Betting Odds: Everything You Need to Know",
  date: "2025-06-07",
  author: "Vikash Roy",
  views: 8931,
  likes: 479,
  comments: 0,
  excerpt: " Tennis betting odds play a vital role in sports betting, giving you insight into the...",
  imageUrl: '/blog11.webp',
},
{
  id: 12,
  slug: "us-open-tennis-betting-what-you-need-to-know-before-you-place-a-bet",
  title: "US Open Tennis Betting: What You Need to Know Before You Place a Bet",
  date: "2025-06-23",
  author: "Vikash Roy",
  views: 7194,
  likes: 89,
  comments: 0,
  excerpt: "The U.S. Open is where tennis dreams are made and betting fortunes are found...",
  imageUrl: '/blog12.webp',
},
{
  id: 13,
  slug: "tennis-betting-odds-your-complete-guide-to-winning-big",
  title: "Tennis Betting Odds: Your Complete Guide to Winning Big",
  date: "2025-06-23",
  author: "Vikash Roy",
  views: 7642,
  likes: 759,
  comments: 0,
  excerpt: " Tennis betting has really come into its own over the past 10 years, and it's become...",
  imageUrl: '/blog13.webp',
},
];

const Blogs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blogs-container">
      <div className='blogs-title'>
      <h1><span className='highlight'>Reddy Anna</span> Latest Blogs</h1>
      </div>
      
      <div className='blog-cards'>
      {blogsData.map((blog) => (
        <div key={blog.id} className="blog-card">
          <img src={blog.imageUrl} alt={blog.title} className="blog-image" />
          <div className="blog-content">
            <h3 className="blog-title">{blog.title}</h3>
            <p className="blog-meta">
                By <span className="blog-author">{blog.author}</span> |{" "}
                <span className="date-published">
                  Published on: <time dateTime={blog.date}>
                    {new Date(blog.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </time>
                </span>
              </p>

            <div className="blog-stats">
              <span>👁 {blog.views}</span>
              <span>👍 {blog.likes}</span>
              <span>💬 {blog.comments} Comments</span>
            </div>
            <p className="blog-excerpt">{blog.excerpt}</p>
            <Link to={`/blogs/${blog.slug}`} className="read-more-button">
              Read More
            </Link>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
};

export default Blogs;
